import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import { register as registerSW, setupPWAInstallPrompt, setupOfflineHandling } from './utils/serviceWorker';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// Register service worker for caching and offline functionality
registerSW({
  onSuccess: (registration) => {
    console.log('🎉 Service Worker registered successfully for offline caching');
  },
  onUpdate: (registration) => {
    console.log('🔄 New app version available');
    // You can add custom update notification logic here
  },
});

// Setup PWA installation prompt
setupPWAInstallPrompt();

// Setup offline status handling
setupOfflineHandling();

console.log('🚀 Ultralendr.ai initialized with advanced caching');
